import { useTranslation } from '@cobliteam/i18n';
import Tag from '@cobliteam/ui/components/Tag';
import Icon from '@cobliteam/ui/icons';

const OngoingRouteBadge = () => {
  const { t } = useTranslation('tracking');
  return <Tag icon={<Icon name='radio' />} variant='surface' size='sm' color='primary' label={t('ongoing_route')} />;
};

export default OngoingRouteBadge;
